import { render, staticRenderFns } from "./ColorButton.vue?vue&type=template&id=2c074172&scoped=true&"
import script from "./ColorButton.vue?vue&type=script&lang=js&"
export * from "./ColorButton.vue?vue&type=script&lang=js&"
import style0 from "./ColorButton.vue?vue&type=style&index=0&id=2c074172&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c074172",
  null
  
)

export default component.exports